import actions from 'src/modules/userEntitlement/deactivate/userEntitlementDeactivateActions';

const initialData = {
  loading: false,
};

export default (state = initialData, { type, payload }) => {
  if (type === actions.DEACTIVATE_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.DEACTIVATE_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.DEACTIVATE_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  return state;
};
